export const RELEASE_BRANCH_PATTERN = /^release\/omnetic-(\d+)\.(\d+)$/;
